import { EntityNumber } from '@/redux/entityNumber/entityNumber.types';
import { PinItem, TargetElement } from '../PinsList.types';

interface Options {
  entityNumber: EntityNumber;
}

export const getTargetElementsUniqueSorted = (
  pinsList: PinItem[],
  { entityNumber }: Options,
): TargetElement[] => {
  const targets = pinsList.map(p => p.data.targets).flat();
  const targetsElementsKeyValue: [number, TargetElement][] = targets
    .map(
      (target): [number, TargetElement][] =>
        target.targetElements?.map(element => [element.id, { target, element }]) || [],
    )
    .flat();
  const targetElementsDict = Object.fromEntries(targetsElementsKeyValue);
  const targetElementsUnique = Object.values(targetElementsDict);

  return targetElementsUnique.sort(
    (a, b) => entityNumber[a.element.id] - entityNumber[b.element.id],
  );
};
